export const environment = {
  production: true,
  x_tenant_code: 'pizza',
  logo_url: "https://delivergate-logos.s3.eu-west-2.amazonaws.com/delivergate.png",
  store_name: 'Pizza',
  branch_name: 'Kollupitiya',
  tenant_id: '10',
  currency: '£',
  currency_text: 'Pound',
  currency_logo: 'pound.png',
};
